import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCheckboxInputComponent } from './checkbox-input.component';

@NgModule({
  declarations: [AppCheckboxInputComponent],
  imports: [CommonModule],
  exports: [AppCheckboxInputComponent],
})
export class AppCheckboxInputModule {}
